export default __webpack_public_path__ + "static/media/ocean.47cee34e.jpg";